import { BillingTypeEnum } from "@/lib/enum/billingType.enum";
import { Filter, FilterTypes, IsFilterable, FilterConfig } from "@/lib/filterable";
import {
  ThgBillingViewmodelGen,
  ThgTimeStampViewModelGen,
  ThgAccountingRecordItemGen,
  ThgBasePdfGen
} from "@/services/thg/v1/data-contracts";
import { AccountingRecordItem } from "@/models/accounting-record.entity";
import {} from "@/lib/utility/t";
import { Timestamp } from "./timestamp.entity";

@IsFilterable
class BillingBase implements ThgBillingViewmodelGen {
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.billing.billingNumber"
  })
  billingNumber: number;

  @FilterConfig({
    type: FilterTypes.ENUM,
    config: { items: Object.values(BillingTypeEnum) },
    displayName: "objects.billing.type"
  })
  type: BillingTypeEnum;

  @FilterConfig({
    type: FilterTypes.OBJECT_ID,
    displayName: "objects.billing.referenceIds"
  })
  referenceIds?: string[] | undefined;

  // Make searchable in backend to enable this
  // @IsSearchable({
  //   type: AccountingRecordItem
  // })
  accountRecord: ThgAccountingRecordItemGen[];

  pdfBilling: ThgBasePdfGen[];

  @FilterConfig({
    type: Timestamp
  })
  timestamp: ThgTimeStampViewModelGen;

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "objects.billing.accountNumber"
  })
  accountNumber: number;

  id: string;

  @FilterConfig({
    type: FilterTypes.BOOLEAN,
    displayName: "objects.billing.isPublished"
  })
  isPublished: boolean;

  thgId?: string | undefined;

  @FilterConfig({ type: FilterTypes.OBJECT_ID, displayName: "objects.billing.partnerId" })
  partnerId?: string | undefined;

  @FilterConfig({ type: FilterTypes.OBJECT_ID, displayName: "objects.billing.userId" })
  userId: string;

  constructor(billing?: Partial<ThgBillingViewmodelGen>) {
    this.billingNumber = billing?.billingNumber || 0;
    this.type = billing?.type as BillingTypeEnum;
    this.referenceIds = billing?.referenceIds || [];
    this.accountRecord = billing?.accountRecord?.map(r => new AccountingRecordItem(r)) || [];
    this.pdfBilling = billing?.pdfBilling || [];
    this.timestamp = billing?.timestamp as ThgTimeStampViewModelGen;
    this.accountNumber = billing?.accountNumber || -1;
    this.id = billing?.id || "";
    this.isPublished = billing?.isPublished || false;
    this.thgId = billing?.thgId || "";
    this.partnerId = billing?.partnerId || "";
    this.userId = billing?.userId || "";
  }
}

export const Billing = Filter.createForClass(BillingBase);
